import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import {
  MdApproval,
  MdDeleteOutline,
  MdOutlineDirections,
  MdOutlineFormatSize,
  MdOutlineLocationOn,
  MdOutlineTipsAndUpdates,
} from "react-icons/md";
import Testimonial from "../components/Sections/Testimonial";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { animateScroll as scroll } from "react-scroll";
import axios from "axios";
import { HashLoader } from "react-spinners";
import { IoSend } from "react-icons/io5";
import { List } from "react-movable";
// city
import cities from "../assets/static/cities.json";
import { ErrorAlert } from "../components/Elements/SweetAlerts";
import { FaRoute } from "react-icons/fa";

const GoogleRoutePage = () => {
  const history = useHistory();
  const [isDragging, setIsDragging] = useState(false);
  const formikRef = useRef(null);

  // ATS Result
  const [loading, setLoading] = useState(false);
  const [showLocations, setShowLocations] = useState(false);
  const [items, setItems] = useState([]);
  const [mapRedirect, setMapRedirect] = useState("https://www.google.com/maps");

  // Initial values
  const initialValues = {
    city: "",
    routeDescription: "",
  };

  // Demo routes data
  const demoRoutes = [
    {
      id: 1,
      title: "Mumbai Shopping Tour",
      city: "Mumbai,Maharashtra",
      description: "Start from Gateway of India, visit Colaba Causeway for shopping, then go to Marine Drive, and end at Juhu Beach",
    },
    {
      id: 2,
      title: "Delhi Heritage Route",
      city: "Delhi,Delhi",
      description: "Start from Red Fort, visit India Gate, then go to Lotus Temple, and end at Qutub Minar",
    },
    {
      id: 3,
      title: "Bengaluru Tech Parks",
      city: "Bengaluru,Karnataka",
      description: "Start from MG Road, visit Cubbon Park, then go to Lalbagh Botanical Garden, and end at Bangalore Palace",
    },
    {
      id: 4,
      title: "Hyderabad City Tour",
      city: "Hyderabad,Telangana",
      description: "Start from Charminar, visit Golconda Fort, then go to Hussain Sagar Lake, and end at Ramoji Film City",
    },
    {
      id: 5,
      title: "Chennai Beach Route",
      city: "Chennai,Tamil Nadu",
      description: "Start from Marina Beach, visit Fort St. George, then go to Kapaleeshwarar Temple, and end at San Thome Basilica",
    },
  ];

  // Handle demo route click
  const handleDemoRoute = (demoRoute) => {
    if (formikRef.current) {
      // Clear previous results
      setShowLocations(false);
      setItems([]);
      setMapRedirect("https://www.google.com/maps");
      
      // Set form values
      formikRef.current.setFieldValue("city", demoRoute.city);
      formikRef.current.setFieldValue("routeDescription", demoRoute.description);
      
      // Submit the form after setting values
      setTimeout(() => {
        formikRef.current.submitForm();
        // Scroll to form section
        scroll.scrollTo(400, { smooth: true, duration: 500 });
      }, 100);
    }
  };

  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  /**
   * Validation schema for the form using Yup
   */
  const validationSchema = Yup.object({
    city: Yup.string().required("Please select a city"),
    routeDescription: Yup.string().required("Route description is required"),
  });

  // const handleSubmit = (values, { setSubmitting }) => {
  //   console.log("Form submitted with values:", values);
  //   setShowLocations(false);
  //   setLoading(true);

  //   setTimeout(async () => {
  //     // "https://hook.us2.make.com/9ryikaxieq0sga63ovldukkijph3nhng",
  //     try {
  //       const response = await axios.post(
  //         "https://test.ct-n8n.ctserver.space/webhook-test/74725c91-4183-43b1-9224-7b4ab0a5d093",
  //         values
  //       );
  //       console.log(
  //         "🚀 ~ GoogleRouteAgent.jsx:78 ~ setTimeout ~ response:",
  //         response
  //       );

  //       setSubmitting(false);
  //       setShowLocations(true);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error uploading:", error);
  //       setLoading(false);
  //     }
  //   }, 1000);
  // };

  const handleSubmit = async (values, { setSubmitting }) => {
    console.log(
      "🚀 ~ GoogleRouteAgent.jsx:148 ~ handleSubmit ~ values:",
      values
    );

    setShowLocations(false);
    setLoading(true);
    let prompt = `All locations are from ${values.city} please consider only that, ${values.routeDescription}`;
    try {
      console.log(
        "🚀 ~ GoogleRouteAgent.jsx:97 ~ handleSubmit ~ prompt:",
        prompt
      );
      const response = await axios.post(
        // "https://test.ct-n8n.ctserver.space/webhook-test/74725c91-4183-43b1-9224-7b4ab0a5d093",
        "https://test.ct-n8n.ctserver.space/webhook/74725c91-4183-43b1-9224-7b4ab0a5d093",
        { text: prompt }
      );
      console.log(
        "🚀 ~ GoogleRouteAgent.jsx:101 ~ handleSubmit ~ response:",
        response
      );

      if (response.data) {
        let data = response.data;
        let routeData = [];

        if (data.source) {
          routeData.push({
            label: data.source.name,
            time: formatDuration(data.source.duration),
            distance: formatDistance(data.source.distance),
          });
        }
        if (data.waypoints) {
          data.waypoints.map((itm) => {
            routeData.push({
              label: itm.name,
              time: formatDuration(itm.duration),
              distance: formatDistance(itm.distance),
            });
          });
        }
        if (data.destination) {
          routeData.push({
            label: data.destination.name,
            time: formatDuration(data.destination.duration),
            distance: formatDistance(data.destination.distance),
          });
        }
        if (data.googleMaplink) {
          setMapRedirect(data.googleMaplink);
        }

        setItems(routeData);
      }

      setShowLocations(true);
    } catch (error) {
      console.error("Error uploading:", error);
      ErrorAlert();
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  function formatDistance(meters) {
    return `${(meters / 1000).toFixed(2)} km`;
  }

  function formatDuration(seconds) {
    const minutes = Math.round(seconds / 60);
    if (minutes < 60) {
      return `${minutes} min`;
    } else {
      const hours = Math.floor(minutes / 60);
      const remMinutes = minutes % 60;
      return `${hours} hr ${remMinutes} min`;
    }
  }

  return (
    <>
      <Wrapper className="flexNullCenter flexColumn">
        <HeroContainer>
          <ContentWrapper>
            <TextContent>
              <Title>Google SmartRoute Planner</Title>
              <Description>
                SmartRoute Planner automatically calculates the most efficient
                sequence for your stops, saving you valuable time and fuel.
                Unlike standard Google Maps which requires manual reordering of
                stops.
              </Description>
            </TextContent>
          </ContentWrapper>
          <Formik
            innerRef={formikRef}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form style={{ width: "100%" }}>
                <DemoRoutesSection>
                  <DemoRoutesHeader>
                    <h3 className="font20 extraBold">Try Demo Routes</h3>
                    <p className="font13">
                      Click on any demo route below to automatically fill and generate the route
                    </p>
                  </DemoRoutesHeader>
                  <DemoRoutesGrid>
                    {demoRoutes.map((route) => (
                      <DemoRouteCard key={route.id} className="whiteBg radius8 shadow">
                        <DemoRouteTitle className="font16 extraBold">
                          {route.title}
                        </DemoRouteTitle>
                        <DemoRouteCity className="font13">
                          📍 {route.city.split(",")[0]}
                        </DemoRouteCity>
                        <DemoRouteDesc className="font12">
                          {route.description}
                        </DemoRouteDesc>
                        <DemoRouteButton
                          type="button"
                          onClick={() => handleDemoRoute(route)}
                          disabled={isSubmitting || loading}
                        >
                          Try it
                        </DemoRouteButton>
                      </DemoRouteCard>
                    ))}
                  </DemoRoutesGrid>
                </DemoRoutesSection>
                <DemoWrapper>
                  <DemoDiv>
                    <div className="col-lg-4">
                      <FormGroup>
                        <Label htmlFor="city">Select a City</Label>
                        <Field as={StyledSelect} name="city">
                          <option value="">Select a city</option>
                          {cities.map((city) => (
                            <option
                              key={city.id}
                              value={`${city.name},${city.state}`}
                            >
                              {city.name},{city.state}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage name="city" component={ErrorText} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-6">
                      <FormGroup>
                        <Label htmlFor="routeDescription">
                          Enter route description
                        </Label>
                        <Field
                          as={TextArea}
                          rows={3}
                          name="routeDescription"
                          placeholder="e.g., Start from Gateway of India, visit Colaba Causeway for shopping, then go to Marine Drive, and end at Juhu Beach"
                        />
                        <ErrorMessage
                          name="routeDescription"
                          component={ErrorText}
                        />
                      </FormGroup>
                    </div>
                    <div className="col-lg-2 flexCenter">
                      <FormGroup>
                        <SubmitButton type="submit" disabled={isSubmitting}>
                          {isSubmitting ? <IoSend /> : <IoSend />}
                        </SubmitButton>
                      </FormGroup>
                    </div>

                    {/* Separate submit button outside the Formik form */}
                    {/* <Formik
                      initialValues={initialValues}
                      onSubmit={handleSubmit}
                    >
                      {({ isSubmitting, submitForm }) => (
                        <SubmitButton
                          type="button"
                          onClick={submitForm}
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Submitting..." : "Submit"}
                        </SubmitButton>
                      )}
                    </Formik> */}
                  </DemoDiv>

                  {loading ? (
                    <div
                      style={{
                        padding: "50px 0px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <HashLoader
                        color="#7620ff"
                        loading={loading}
                        size={150}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    </div>
                  ) : (
                    showLocations && (
                      <div>
                        <List
                          values={items}
                          onChange={({ oldIndex, newIndex }) => {
                            const updated = [...items];
                            const [moved] = updated.splice(oldIndex, 1);
                            updated.splice(newIndex, 0, moved);
                            setItems(updated);
                          }}
                          renderList={({ children, props }) => (
                            <div {...props}>{children}</div>
                          )}
                          renderItem={({ value, props, isDragged }) => (
                            <ListItem
                              {...props}
                              style={{
                                ...props.style,
                                boxShadow: isDragged
                                  ? "0 4px 16px rgba(0,0,0,0.10)"
                                  : "0 1px 4px rgba(0,0,0,0.03)",
                                opacity: isDragged ? 0.9 : 1,
                                zIndex: isDragged ? 2 : 1,
                              }}
                            >
                              <TitleRow>
                                <Icon>≡</Icon>
                                {value.label}
                              </TitleRow>
                              {value.time && value.distance && (
                                <SubInfo>
                                  <span>
                                    ↓ {value.time} ({value.distance})
                                  </span>
                                </SubInfo>
                              )}
                            </ListItem>
                          )}
                        />
                        <div>
                          <GoogleMapBtn>
                            <a
                              href={mapRedirect}
                              target="_blank"
                              style={{ color: "white" }}
                            >
                              Google Map
                            </a>
                          </GoogleMapBtn>
                        </div>
                      </div>
                    )
                  )}
                </DemoWrapper>
              </Form>
            )}
          </Formik>
        </HeroContainer>
      </Wrapper>

      <DemoSampleWrapper className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Features</h1>
            <p className="font13">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut
              <br />
              labore et dolore magna aliquyam erat, sed diam voluptua.
            </p>
          </HeaderInfo>
          <DemoSampleWrapperDiv>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <MdOutlineDirections fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Route Optimizer
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Efficient Shortest Route Calculation Quickly finds the fastest
                route between your locations, saving time and fuel.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <MdOutlineLocationOn fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Flexible Location
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Specify origins, destinations, and waypoints using text
                addresses, place IDs, or precise latitude and longitude
                coordinates.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <FaRoute fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Waypoint Management
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Easily set stopover points and pass-through locations to
                customize your journey.
              </DemoFeatureDesc>
            </FeatureWrapper>
          </DemoSampleWrapperDiv>
        </div>
      </DemoSampleWrapper>

      {/* Testimonial */}
      <Testimonial />
    </>
  );
};

const Wrapper = styled.section`
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
  padding: 110px 30px 0px 30px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const HeroContainer = styled.section`
  background-color: #f9fafb;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 32px;
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 32px;

  @media (max-width: 1024px) {
    flex-direction: column;
    text-align: center;
  }
`;

const TextContent = styled.div`
  flex: 1;
  min-width: 300px;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
`;

const Description = styled.p`
  font-size: 18px;
  color: #6b7280;
  margin-bottom: 32px;
  line-height: 2;
`;

const DemoSampleWrapper = styled.div`
  margin-top: 50px;
  padding: 50px 0px;
`;

const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const DemoSampleWrapperDiv = styled.div`
  width: 100%;
  max-width: 1220px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const FeatureWrapper = styled.div`
  width: 350px;
  height: 220px;
  text-align: left;
  padding: 20px 30px;
  margin: 30px 0px;
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: scale(1.05) translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  }
`;

const DemoFeatureDiv = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const DemoFeatureIcon = styled.div`
  width: 30%;
  width: 60px;
  height: 60px;
  background-color: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

const DemoFeatureTitle = styled.h3`
  width: 70%;
  padding: 10px 15px;
`;

const DemoFeatureDesc = styled.p`
  padding: 10px 0px;
`;

const DemoWrapper = styled.div`
  width: 100%;
`;

const DemoDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;

  @media (max-width: 860px) {
    flex-direction: column;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 15px;
`;

const TextArea = styled.textarea`
  width: 100%;
  height: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #7620ff;
  }
`;

const StyledSelect = styled.select`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;
  outline: none;
  &:focus {
    outline: none;
    border-color: #7620ff;
  }
`;

const ErrorText = styled.div`
  color: #e74c3c;
  font-size: 14px;
  margin-top: 5px;
`;

const Label = styled.label`
  margin-bottom: 6px;
  font-weight: 500;
  color: #0b093b;
`;

const SubmitButton = styled.button`
  background-color: #7620ff;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  box-shadow: 0 4px 6px rgba(118, 32, 255, 0.2);

  &:hover {
    background-color: #6010e2;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background-color: #b794f6;
    cursor: not-allowed;
    transform: none;
  }
`;

const ListItem = styled.div`
  background: #fff;
  border-radius: 8px;
  margin-bottom: 18px;
  padding: 18px 16px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  position: relative;
`;

const TitleRow = styled.div`
  font-size: 1.08rem;
  font-weight: 500;
  color: #222;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
`;

const Icon = styled.span`
  display: inline-block;
  margin-right: 12px;
  font-size: 1.2rem;
  color: #888;
`;

const SubInfo = styled.div`
  font-size: 0.98rem;
  color: #666;
  margin-left: 2.2rem;
`;

const GoogleMapBtn = styled.button`
  background-color: #7620ff;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  box-shadow: 0 4px 6px rgba(118, 32, 255, 0.2);

  &:hover {
    background-color: #6010e2;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background-color: #b794f6;
    cursor: not-allowed;
    transform: none;
  }
`;

const DemoRoutesSection = styled.div`
  width: 100%;
  margin-bottom: 40px;
  padding: 30px 0;
`;

const DemoRoutesHeader = styled.div`
  text-align: center;
  margin-bottom: 30px;
  
  h3 {
    margin-bottom: 10px;
    color: #1f2937;
  }
  
  p {
    color: #6b7280;
  }
`;

const DemoRoutesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  width: 100%;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const DemoRouteCard = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }
`;

const DemoRouteTitle = styled.h4`
  color: #1f2937;
  margin-bottom: 8px;
`;

const DemoRouteCity = styled.div`
  color: #7620ff;
  margin-bottom: 12px;
  font-weight: 500;
`;

const DemoRouteDesc = styled.p`
  color: #6b7280;
  margin-bottom: 16px;
  line-height: 1.6;
  flex-grow: 1;
`;

const DemoRouteButton = styled.button`
  background-color: #7620ff;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  box-shadow: 0 2px 4px rgba(118, 32, 255, 0.2);
  align-self: flex-start;
  margin-top: auto;

  &:hover {
    background-color: #6010e2;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background-color: #b794f6;
    cursor: not-allowed;
    transform: none;
  }
`;

export default GoogleRoutePage;
